import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import styles from './Table.module.scss';

const TableHead = ({ columns, className, noBordered, hasCellMinWidth, centeredText }) => (
  <thead className={classnames(styles.head, className)}>
    <tr>
      {columns.map(column => (
        <th
          key={column.id}
          {...column.headProps}
          className={classnames({
            [styles.bordered]: !noBordered,
            [styles.minWidth]: hasCellMinWidth,
            'has-text-centered': centeredText,
          })}
        >
          {column.label}
        </th>
      ))}
    </tr>
  </thead>
);

TableHead.propTypes = {
  className: PropTypes.string,
  columns: PropTypes.array.isRequired,
  noBordered: PropTypes.bool,
  hasCellMinWidth: PropTypes.bool,
  centeredText: PropTypes.bool,
};

TableHead.defaultProps = {
  className: null,
  noBordered: false,
  hasCellMinWidth: false,
  centeredText: false,
};

export { TableHead };
